// extracted by mini-css-extract-plugin
export default {"pageLoader":"PageLoader_pageLoader__JrnTr","text":"PageLoader_text__BT-VT","embedded":"PageLoader_embedded__cnRAi"};